import buildSimpleStringFilter from '../buildSimpleStringFilter'

const ProductTypeFilter = buildSimpleStringFilter({
  key: 'productType',
  expandedOnInit: false,
})

export default ProductTypeFilter
